// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"918c7392","356":"918c7392","854":"918c7392","888":"918c7392","960":"918c7392","969":"918c7392"}[chunkId] + ".chunk.css";
};